export { AccordPage } from './pages/AccordPage';
export { DISCOUNT_CODE } from './constants';
